var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17.5,
    viewBox: "0 0 14 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-1523 -41.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_FILL0_wght400_GRAD0_opsz48",
    d: "M15,12.531a1.531,1.531,0,0,0,1.083-2.614,1.531,1.531,0,0,0-2.166,2.166A1.475,1.475,0,0,0,15,12.531Zm0,7.241a25.621,25.621,0,0,0,4.3-4.8,7.284,7.284,0,0,0,1.389-3.8,5.694,5.694,0,0,0-1.652-4.222A5.509,5.509,0,0,0,15,5.313a5.509,5.509,0,0,0-4.036,1.641,5.694,5.694,0,0,0-1.652,4.222,7.178,7.178,0,0,0,1.422,3.8A27.821,27.821,0,0,0,15,19.772ZM15,21.5a29.088,29.088,0,0,1-5.261-5.567A8.657,8.657,0,0,1,8,11.175a6.767,6.767,0,0,1,2.111-5.228,7.112,7.112,0,0,1,9.778,0A6.767,6.767,0,0,1,22,11.175a8.658,8.658,0,0,1-1.739,4.758A29.088,29.088,0,0,1,15,21.5ZM15,11.175Z",
    transform: "translate(1515 37.75)",
    fill: "#2e90d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fe5b1f4ff0e4e2c8dfcbd2d689ffb2b7.svg";
export { ForwardRef as ReactComponent };